const fetchFsa = (...args) => {
    return fetch(...args).then(response => {
        if (response.status === 200) {
            return Promise.resolve(response.json());
        }
        //resource created, request completed, can be update.
        if (response.status === 201) {
            return Promise.resolve(response.json());
        }
        //request accepted for long running requests not completed by time response is returned.
        if (response.status === 202) {
            return Promise.resolve(response.json());
        }
        return Promise.resolve(response.json()).then(error => {
            return Promise.reject(new Error(error.message));
        });
    });
};

export { fetchFsa as default };
